import { defineMessages } from "react-intl";

const MERGE_ALERT = "merge-alert";

const mergeAlertMessages = defineMessages({
  organizationMismatch: {
    id: `${MERGE_ALERT}.organization-mismatch`,
    defaultMessage:
      "Organization mismatch. Organizations do not always provide the same content. Content will only be viewable within the organization that you are currently signed in to."
  },
  hasAssignedRole: {
    id: `${MERGE_ALERT}.has-assigned-role`,
    defaultMessage:
      "Your account has an assigned role associated with your account. Roles will not be merged from <styledUsername>{username}</styledUsername>."
  },
  hasHolds: {
    id: `${MERGE_ALERT}.has-holds`,
    defaultMessage:
      "Your account has holds on an eBook or audiobook. Holds will not be merged from <styledUsername>{username}</styledUsername>."
  },
  hasCheckouts: {
    id: `${MERGE_ALERT}.has-checkouts`,
    defaultMessage: "Your account has an eBook or audiobook checked out."
  },
  hasEducationCredits: {
    id: `${MERGE_ALERT}.has-education-credits`,
    defaultMessage:
      "Your account has pending or existing Continuing Medical Education credits."
  },
  expiredSession: {
    id: `${MERGE_ALERT}.expired-session`,
    defaultMessage: "Your session has expired."
  },
  sameAccount: {
    id: `${MERGE_ALERT}.same-account`,
    defaultMessage:
      "You cannot merge into the same account. Please sign in to an account other than <styledUsername>{username}</styledUsername>."
  }
});

export default mergeAlertMessages;
